export default "__VITE_ASSET__cyyJ54qd__"